import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import getData from '../functions/getData'
import { PROGRAM_WEISCHERADS } from '../constants/state'


const mapStateToProps = (state, ownProps) => ({
    item: getData(state, [PROGRAM_WEISCHERADS, ownProps.id]),
})

const ItemWeischerAccess = ({
    item
}) => {
    return (
        <article>
            item
        </article>
    )
}


export default compose(
    connect(mapStateToProps, null),
    toJS()
)(ItemWeischerAccess)